import React from "react";
import useScrollToTop from "./../../../hooks/useScollToTop";

import useTrombinosAdmin from "./hooks/useTrombinosAdmin";

import TrombinosHero from "./components/TrombinosHero";
import TrombinosStatsGrid from "./components/TrombinosStatsGrid";
import TrombinosFiltersPanel from "./components/TrombinosFiltersPanel";
import TrombinosList from "./components/TrombinosList";
import TrombinosFormDrawer from "./components/TrombinosFormDrawer";
import TrombinosPreviewDrawer from "./components/TrombinosPreviewDrawer";
import TrombinosDeleteDrawer from "./components/TrombinosDeleteDrawer";
import TrombinosMediaPickerDrawer from "./components/TrombinosMediaPickerDrawer";

export default function TrombinosAdmin() {
  useScrollToTop();
  const trombinos = useTrombinosAdmin();

  return (
    <div className="mx-auto w-full max-w-[1600px] px-1 pb-10 sm:px-2 lg:px-0">
      <TrombinosHero
        stats={trombinos.stats}
        loading={trombinos.loading}
        onCreate={trombinos.openCreate}
      />

      {trombinos.notice ? (
        <div className="mt-5 rounded-[1.5rem] border border-emerald-200 bg-emerald-50 px-5 py-4 text-sm font-bold text-emerald-800 shadow-sm dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          {trombinos.notice}
        </div>
      ) : null}

      {trombinos.error ? (
        <div className="mt-5 rounded-[1.5rem] border border-rose-200 bg-rose-50 px-5 py-4 text-sm font-bold text-rose-800 shadow-sm dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
          {trombinos.error}
        </div>
      ) : null}

      <TrombinosStatsGrid
        stats={trombinos.stats}
        loading={trombinos.loading}
      />

      <TrombinosFiltersPanel
        q={trombinos.q}
        electedFilter={trombinos.electedFilter}
        visibleFilter={trombinos.visibleFilter}
        serviceFilter={trombinos.serviceFilter}
        servicesOptions={trombinos.servicesOptions}
        limit={trombinos.limit}
        onChangeQ={trombinos.setQ}
        onChangeElectedFilter={trombinos.changeElectedFilter}
        onChangeVisibleFilter={trombinos.changeVisibleFilter}
        onChangeServiceFilter={trombinos.changeServiceFilter}
        onChangeLimit={trombinos.changeLimit}
        onSubmit={trombinos.onSubmitSearch}
        onReset={trombinos.resetFilters}
        onRefresh={trombinos.fetchData}
        loading={trombinos.loading}
      />

      <TrombinosList
        items={trombinos.items}
        loading={trombinos.loading}
        total={trombinos.total}
        page={trombinos.page}
        totalPages={trombinos.totalPages}
        actionId={trombinos.actionId}
        onPageChange={trombinos.setPage}
        onPreview={trombinos.openPreview}
        onEdit={trombinos.openEdit}
        onToggleVisible={trombinos.onToggleVisible}
        onToggleElected={trombinos.onToggleElected}
        onAskDelete={trombinos.openDelete}
      />

      <TrombinosFormDrawer
        open={trombinos.formOpen}
        form={trombinos.form}
        fieldErrors={trombinos.fieldErrors}
        saving={trombinos.saving}
        isEdit={!!trombinos.currentId}
        servicesOptions={trombinos.servicesOptions}
        onClose={trombinos.closeForm}
        onChange={trombinos.updateFormField}
        onSave={trombinos.onSave}
        onOpenMediaPicker={trombinos.openMediaPicker}
      />

      <TrombinosPreviewDrawer
        open={!!trombinos.previewItem}
        item={trombinos.previewItem}
        onClose={trombinos.closePreview}
        onEditFromPreview={trombinos.openEditFromPreview}
      />

      <TrombinosDeleteDrawer
        open={!!trombinos.deleteItem}
        item={trombinos.deleteItem}
        deleting={trombinos.deleting}
        onClose={trombinos.closeDelete}
        onConfirm={trombinos.onDelete}
      />

      <TrombinosMediaPickerDrawer
        open={trombinos.mediaPickerOpen}
        onClose={trombinos.closeMediaPicker}
        onSelect={trombinos.handleSelectMedia}
      />
    </div>
  );
}